// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { openTabOrSave } = require('../../insuranceUtilities/fileHelper');

// @ constants
const { DOCUMENT_TYPES: { POLICY } } = require('../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_PRODUCT_DETAIL_INFORMATION,
    INSURANCE_REQUEST_PRODUCT_DETAIL_WRONG_REQUEST,
    INSURANCE_REQUEST_FETCH_POLICY_IN_PROGRESS,
    INSURANCE_REQUEST_FETCH_POLICY_SUCCESS,
    INSURANCE_REQUEST_FETCH_POLICY_FAILURE,
    INSURANCE_REQUEST_PRODUCT_DETAIL_IS_FETCHING
} = require('../../insuranceConstants/actionTypes');

const saveProductDetailInformation = response => ({
    type: INSURANCE_REQUEST_PRODUCT_DETAIL_INFORMATION,
    data: { response }
});

const wrongRequestProductDetailInformation = () => ({
    type: INSURANCE_REQUEST_PRODUCT_DETAIL_WRONG_REQUEST,
});

const isFetchingDetailInformation = () => ({
    type: INSURANCE_REQUEST_PRODUCT_DETAIL_IS_FETCHING,
});

const fetchPolicyDocumentInProgress = () => ({
    type: INSURANCE_REQUEST_FETCH_POLICY_IN_PROGRESS,
});

const fetchPolicyDocumentSuccess = pdfData => ({
    type: INSURANCE_REQUEST_FETCH_POLICY_SUCCESS,
    data: { pdfData }
});

const fetchPolicyDocumentFailure = () => ({
    type: INSURANCE_REQUEST_FETCH_POLICY_FAILURE,
});

const getProductDetail = policyNumber => (dispatch) => {
    const requestData = {
        query: {
            policyNumber,
        }
    };
    dispatch(isFetchingDetailInformation());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestProductDetail'),
        requestData
    )
        .then(response => {
            const { data } = response;
            dispatch(saveProductDetailInformation(data));
        })
        .catch(() => {
            dispatch(wrongRequestProductDetailInformation());
        });
};

const getPolicyDocument = (policyCode, policyVersion) => (dispatch) => {
    dispatch(fetchPolicyDocumentInProgress())
    const requestData = {
        query: {
            policyNumber: policyCode,
            policyVersion: policyVersion,
            documentType: POLICY
        }
    };
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestProductDetailContratedDocument'),
        requestData
    )
        .then(response => {
            const { base64, contentType } = response.data;
            const filename = formatText('insuranceRequestHome-confirmationPolicy');
            const base64Info = {
                base64string: base64,
                filename,
                contentType,
            };

            openTabOrSave(base64, contentType, filename);

            dispatch(fetchPolicyDocumentSuccess(base64Info));
        })
        .catch(() => {
            dispatch(fetchPolicyDocumentFailure());
        })
};

module.exports = {
    getProductDetail,
    getPolicyDocument
};
